import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../../ui/Avatar';

import type { Space } from '../../../_hooks/useSpace';
import { useSpaceAccess } from '../../../_hooks/useSpaceAccess';
import { useSpaceMembers } from '../../../_hooks/useSpaceMembers';
import { SpaceMembersDialog } from './SpaceMembersDialog';

const FACE_COUNT = 3;

export const SpaceMembers: FC<{ space: Space }> = ({ space }) => {
  const { t } = useTranslation();
  const { listsMembers } = useSpaceAccess();
  const [isOpen, setIsOpen] = useState(false);
  const isListed = listsMembers(space);
  const { members, totalCount, ...feed } = useSpaceMembers(space.slug, isListed);

  if (!isListed || totalCount === 0) return null;

  const countLabel = t('community.profile.channels_card_members', { count: totalCount });

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
        className="flex items-center gap-2 rounded-full py-1 pl-1 pr-2 transition-colors hover:bg-black/5"
      >
        <span className="flex -space-x-2" aria-hidden="true">
          {members.slice(0, FACE_COUNT).map((member) => (
            <Avatar
              key={member.id}
              src={member.avatar_url}
              alt=""
              className="size-7 border-2 border-white"
              fallbackClassName="border-2 border-white"
            />
          ))}
        </span>
        <span className="text-sm font-medium text-black/70">{countLabel}</span>
      </button>
      <SpaceMembersDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        spaceName={space.name}
        countLabel={countLabel}
        members={members}
        {...feed}
      />
    </>
  );
};
